export const EPerfomanceCaptureLabel = {
  /*
   * CLIENT
   */
  PAGE_LOADING: 'PAGE_LOADING',

  /*
   * SERVER
   */

  APP_INIT: 'APP_INIT',
  APP_MAINTENANCE: 'APP_MAINTENANCE',
};
